(() => {
  if (window.cartEnhancementsInitialized) return;
  window.cartEnhancementsInitialized = true;

  const feedbackStorageKey = 'cartPromoFeedback';

  function showMessage(form, text, type) {
    const message = form?.querySelector('[data-cart-promo-message]');
    if (!message) return;

    message.textContent = text;
    message.classList.toggle('cart-promo-code__message--error', type === 'error');
    message.classList.toggle('cart-promo-code__message--success', type === 'success');
    message.hidden = !text;
  }

  function collectAppliedDiscounts(cart) {
    const discounts = [];

    (cart.discount_codes || []).forEach((discount) => {
      if (discount.applicable !== false && discount.code) discounts.push(discount.code);
    });

    (cart.cart_level_discount_applications || []).forEach((application) => {
      if (application.title) discounts.push(application.title);
    });

    (cart.items || []).forEach((item) => {
      (item.line_level_discount_allocations || []).forEach((allocation) => {
        const title = allocation.discount_application?.title;
        if (title) discounts.push(title);
      });
    });

    return discounts.map((discount) => String(discount).trim().toUpperCase());
  }

  async function applyDiscount(code) {
    const updateUrl = window.routes?.cart_update_url || '/cart/update.js';
    const response = await fetch(updateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: code })
    });

    const cart = await response.json();
    if (!response.ok) {
      throw new Error(cart.description || cart.message || 'The discount code could not be applied.');
    }

    return cart;
  }

  function restoreFeedback() {
    let feedback;
    try {
      feedback = JSON.parse(window.sessionStorage.getItem(feedbackStorageKey) || 'null');
      window.sessionStorage.removeItem(feedbackStorageKey);
    } catch (error) {
      feedback = null;
    }

    if (!feedback?.text) return;
    document.querySelectorAll('[data-cart-promo-form]').forEach((form) => {
      showMessage(form, feedback.text, feedback.type);
    });
  }

  document.addEventListener('DOMContentLoaded', restoreFeedback);

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-cart-promo-form]');
    if (!form) return;

    event.preventDefault();

    const input = form.querySelector('input[name="discount"]');
    const button = form.querySelector('button[type="submit"]');
    const code = input ? input.value.trim().toUpperCase() : '';

    if (!code) {
      showMessage(form, 'Please enter a promo code.', 'error');
      input?.focus();
      return;
    }

    showMessage(form, '', '');
    if (button) button.disabled = true;

    try {
      const cart = await applyDiscount(code);
      const appliedDiscounts = collectAppliedDiscounts(cart);
      const applied = appliedDiscounts.includes(code);

      if (!applied) {
        showMessage(
          form,
          'This code could not be applied. It may be invalid, expired, ineligible, or incompatible with another discount.',
          'error'
        );
        if (button) button.disabled = false;
        return;
      }

      window.sessionStorage.setItem(
        feedbackStorageKey,
        JSON.stringify({ type: 'success', text: code + ' applied successfully.' })
      );
      window.location.reload();
    } catch (error) {
      showMessage(form, error.message || 'The discount code could not be applied.', 'error');
      if (button) button.disabled = false;
    }
  });
})();
